import { render, staticRenderFns } from "./ParcoursModal.vue?vue&type=template&id=678d6808&scoped=true&"
import script from "./ParcoursModal.vue?vue&type=script&lang=js&"
export * from "./ParcoursModal.vue?vue&type=script&lang=js&"
import style0 from "./ParcoursModal.vue?vue&type=style&index=0&id=678d6808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678d6808",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
